import type { ErrorInfo } from 'react'

import { logError } from 'lib/tracking/datadog'
import { recoverFromChunkLoadError } from 'lib/tracking/helpers/recoverFromChunkLoadError/recoverFromChunkLoadError'
import { isUnauthenticatedError } from 'lib/helpers/isUnauthenticatedError/isUnauthenticatedError'

/**
 * `onError` for the app-wide `PageErrorBoundary`. Reports only what nothing else owns: a
 * stale-deploy `ChunkLoadError` belongs to `recoverFromChunkLoadError`, which auto-reloads (or
 * logs), and a 401 belongs to the Apollo error link, which is already redirecting to `/login`.
 * Everything else is forwarded to `logError`.
 */
export const handlePageError = (error: Error, info: ErrorInfo) => {
  if (recoverFromChunkLoadError({ error, info }) || isUnauthenticatedError(error)) {
    return
  }

  logError(error, { componentStack: info.componentStack })
}
